import { render, staticRenderFns } from "./EditorJsRenderer.vue?vue&type=template&id=49d501ea&scoped=true"
import script from "./EditorJsRenderer.vue?vue&type=script&lang=js"
export * from "./EditorJsRenderer.vue?vue&type=script&lang=js"
import style0 from "./EditorJsRenderer.vue?vue&type=style&index=0&id=49d501ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d501ea",
  null
  
)

export default component.exports